import script from "./InvoiceElectronicTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceElectronicTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceElectronicTable.vue?vue&type=style&index=0&id=0d310aac&lang=css"

const __exports__ = script;

export default __exports__